/**
 * Measurement, consent and attribution — public interface.
 *
 * Port of omega-measure.js (ΩΞ-MARKET-001/010/013, ΩΞ-COOKIE-001) with ML-D1, ML-D2, ML-D3 and
 * ML-D6 applied. Storage keys and consent semantics are shared with the static pages that
 * still load /assets/omega-measure.js.
 *
 * Until `initMeasurement()` has run, `track` queues and `cartAttributes` returns what
 * attribution storage already holds.
 */
import { subscribe as subscribeToNavigation } from '@/lib/router/history';
import { createMeasurement, type ConsentApi, type EventParams, type MeasurementEvent } from './measurement';

export type { AttributionStore, CartAttributeInput, Touch } from './attribution';
export type { ConsentState } from './consent';
export type { MeasurementIds } from './ids';
export type { ConsentApi, EventParams, MeasurementEvent } from './measurement';
export { cartAttributes, clientId, readAttribution } from './attribution';
export { disclosureModel, formatVendorList } from './disclosure';
export { MEASUREMENT_IDS } from './ids';

const measurement = createMeasurement({ onNavigate: subscribeToNavigation });

/** Boot once, before the first render: attribution, client id, consent decision, landing page view. */
export function initMeasurement(): void {
  measurement.init();
}

/** Queue-or-send one event (GA4 names; mapped for Meta and TikTok). */
export function track(name: MeasurementEvent, params?: EventParams): void {
  measurement.track(name, params);
}

export const consent: ConsentApi = measurement.consent;
